var H = require("hogan.js");
window.gettext || require("ehogan-loader/gt.js");
window.jscAdd || require("ehogan-loader/jscmanager.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b(t.t(interpolate( gettext("Возникла ошибка при передаче данных из вашего социального профиля. %(linkTagOpenBegin)s%(url)s%(linkTagOpenEnd)sПопробуйте еще раз%(linkTagClose)s."), {'linkTagOpenBegin': '<a href="', 'url': t.d("authUrl",c,p,1)||"",'linkTagOpenEnd': '">','linkTagClose': '</a>'} , true)));t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "{{{ ___0___ }}}\n", H);return T[arguments[0] instanceof Array ? "ri" : "render"].apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./static-source/messages/external_invalid_parameters.html
// module id = 191
// module chunks = 4